export const CURRENCIES = ['EUR', 'CHF', 'GBP', 'USD', 'DKK', 'NOK', 'SEK'] as const;
export const SCALES_DERIVATIVES = ['THOUSAND', 'THOUSANDS', 'MILLIONS', 'MILLION', 'MIL'] as const;
